import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";

import { ReceiptData, ReceiptState } from "./receipt-state";
import { defaultGenericMeta } from "store/common";
import {  fetchReceipt } from "./receipt-action";

const receiptEntityAdapter = createEntityAdapter<ReceiptData>({});

export const receiptSlice = createSlice({
  name: "receipt",
  initialState: receiptEntityAdapter.getInitialState<ReceiptState>({
    meta: { ...defaultGenericMeta },
  }),
  reducers: {
    setReceiptData(state, action: PayloadAction<ReceiptData>) {
      state.receiptData = action.payload;
    },
    resetInfo(state) {
      delete state.receiptData;
      state.meta = { ...defaultGenericMeta };
    },
  },
  extraReducers: (builder) => {
    /* additional receipt data */
    builder.addCase(
      fetchReceipt.pending, (state) => {
        state.meta.isLoading = true;
        state.meta.status = "inProcess";
      });
    builder.addCase(
      fetchReceipt.fulfilled, 
      (state, action) => {
        state.meta.isLoading = false;
        state.meta.isSuccess = true;
        state.meta.status = "idle";
        state.receiptData = action.payload;
      });
    builder.addCase(
      fetchReceipt.rejected, (state) => {
        state.meta.isLoading = false;
        state.meta.status = "idle";
        state.meta.error = "true";
    });
  },
});

export const { setReceiptData, resetInfo } = receiptSlice.actions;
export default receiptSlice.reducer;
